module.exports = __webpack_public_path__ + "img/img4.a8e9d783.svg";